"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Config = exports.UIConfig = void 0;
const translations = __importStar(require("../translations"));
class UIConfig {
  constructor(config) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    this._languageSelect = config.languageSelect;
    this._noticeStyle = config.noticeStyle;
    this._settingsStyle = config.settingsStyle;
    this._showAcceptAll = (_a = config.showAcceptAll) !== null && _a !== void 0 ? _a : true;
    this.additionalClass = (_b = config.additionalClass) !== null && _b !== void 0 ? _b : "";
    this.showConsentNotice = (_c = config.showConsentNotice) !== null && _c !== void 0 ? _c : true;
    this.showToggleAll = (_d = config.showToggleAll) !== null && _d !== void 0 ? _d : true;
    this.showDeclineAll = (_e = config.showDeclineAll) !== null && _e !== void 0 ? _e : true;
    this.showConsentSettingsLink = (_f = config.showConsentSettingsLink) !== null && _f !== void 0 ? _f : true;
    this.showPurposesInConsentNotice = (_g = config.showPurposesInConsentNotice) !== null && _g !== void 0 ? _g : true;
    this.showAttribution = (_h = config.showAttribution) !== null && _h !== void 0 ? _h : true;
  }
  get noticeStyle() {
    var _a;
    return (_a = this._noticeStyle) !== null && _a !== void 0 ? _a : "wall";
  }
  get settingsStyle() {
    var _a;
    return (_a = this._settingsStyle) !== null && _a !== void 0 ? _a : "wall";
  }
  get showAcceptAll() {
    var _a;
    return (_a = this._showAcceptAll) !== null && _a !== void 0 ? _a : true;
  }
  /**
   * Check if the language select should be displayed at a specific location.
   * @param place
   */
  shouldShowLanguageSelect(place) {
    var _a, _b, _c, _d, _e, _f;
    switch (place) {
      case "consent-notice":
        return (_b = (_a = this._languageSelect) === null || _a === void 0 ? void 0 : _a.showInConsentNotice) !== null && _b !== void 0 ? _b : false;
      case "consent-settings":
        return (_d = (_c = this._languageSelect) === null || _c === void 0 ? void 0 : _c.showInConsentSettings) !== null && _d !== void 0 ? _d : false;
      case "contextual-consent":
        return (_f = (_e = this._languageSelect) === null || _e === void 0 ? void 0 : _e.showInContextualConsent) !== null && _f !== void 0 ? _f : false;
    }
  }
}
exports.UIConfig = UIConfig;
class Config {
  constructor(config) {
    var _a, _b, _c;
    this.ui = new UIConfig(config);
    this.version = config.version || "1";
    this._storageMethod = config.storageMethod;
    this._storageName = config.storageName;
    this._cookieDomain = config.cookieDomain;
    this._cookiePath = config.cookiePath;
    this._cookieExpiresAfterDays = config.cookieExpiresAfterDays;
    this._notConsentedCookieExpiresAfterDays = config.notConsentedCookieExpiresAfterDays;
    this._services = {};
    for (const servicesKey in config.services) {
      this._services[servicesKey] = Object.assign(Object.assign({}, config.services[servicesKey]), {
        purposes: config.services[servicesKey].purposes || ["other"]
      });
    }
    this._purposes = {};
    for (const purposeKey in config.purposes) {
      this._purposes[purposeKey] = config.purposes[purposeKey];
    }
    this._contextualConsents = (_a = config.contextualConsents) !== null && _a !== void 0 ? _a : {};
    this._translations = (_b = config.translations) !== null && _b !== void 0 ? _b : {};
    this.fallbackLanguage = config.fallbackLanguage;
    this.languageStorageName = config.languageStorageName;
    this.language = config.language;
    this.availableLanguages = config.availableLanguages || Object.keys(translations);
    this._renderOnLoad = (_c = config.renderOnLoad) !== null && _c !== void 0 ? _c : true;
  }
  get translations() {
    return this._translations;
  }
  get services() {
    return this._services;
  }
  get purposes() {
    return this._purposes;
  }
  get contextualConsents() {
    return Object.assign({}, this._contextualConsents);
  }
  get renderOnLoad() {
    var _a;
    return (_a = this._renderOnLoad) !== null && _a !== void 0 ? _a : true;
  }
  /**
   * Get the currently used storage method.
   *
   * @returns - A string of the used storageMethod
   */
  get storageMethod() {
    return this._storageMethod || "cookie";
  }
  /**
   * Get the currently used storage name.
   *
   * @returns - A string of the used storageName
   */
  get storageName() {
    return this._storageName || "bryn-consent";
  }
  /**
   * Get the configured cookie domain
   *
   * @returns - The domain used for setting the bryn consent cookie
   */
  get cookieDomain() {
    return this._cookieDomain || undefined;
  }
  /**
   * Get the configured cookie path
   *
   * @returns - The path used for setting the bryn consent cookie
   */
  get cookiePath() {
    return this._cookiePath || undefined;
  }
  /**
   * Get the number of days the consent cookie will be valid for.
   *
   * @returns - The number of days the cookie will be valid for if consent is given
   */
  get cookieExpiresAfterDays() {
    return this._cookieExpiresAfterDays || 365;
  }
  /**
   * Get the number of days the consent cookie will be valid for if consent is denied.
   *
   * @returns - The number of days the cookie will be valid for if consent is denied
   */
  get notConsentedCookieExpiresAfterDays() {
    return this._notConsentedCookieExpiresAfterDays || this.cookieExpiresAfterDays;
  }
}
exports.Config = Config;